import {useSyncExternalStore} from 'react';
import {isHostConnected,subscribeHostConnection} from '../host/client';
/** First-party work transport readiness, never company login or operator permission. */
export const useHostReady=()=>useSyncExternalStore(subscribeHostConnection,isHostConnected,()=>false);
